import {
  Autocomplete as MuiAutocomplete,
  Box as MuiBox,
  Stack as MuiStack,
  TextField as MuiTextField,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { OIS_FILTER_TYPES } from "app/services/OISService/constants";
import { useOIS } from "app/services/OISService/OISProvider";
import UploadFile from "./UploadFile";
import DatePickers from "./EProtocolDatePickers";

const OISSubheader = ({ callBackFilter }) => {
  const { t } = useTranslation();
  const {
    filterOptions: { actions },
    searchFilters: { action },
    updateFilter,
  } = useOIS();

  const OISSubheaderComponents = {
    review: <DatePickers />,
    participants: <UploadFile csvType={t("csvTypes.participants")} />,
    training: <UploadFile csvType={t("csvTypes.training")} />,
  };

  return (
    <MuiBox id="ois-sub-header">
      <MuiStack gap={2} marginBottom={2}>
        <MuiAutocomplete
          id="ois-action-select"
          name={OIS_FILTER_TYPES.ACTION}
          options={actions}
          getOptionLabel={(option) => option.label || ""}
          value={action}
          onChange={(e, val) => updateFilter(OIS_FILTER_TYPES.ACTION, val)}
          openOnFocus
          clearOnEscape
          renderInput={(params) => (
            <MuiTextField
              {...params}
              label={
                action
                  ? t("ois.filter.label.action")
                  : t("ois.filter.label.selectAction")
              }
              variant="outlined"
              size="small"
            />
          )}
          renderOption={(props, option) => (
            <div style={{ fontSize: "14px" }} {...props} key={props.key}>
              {option.label}
            </div>
          )}
          sx={{
            width: 200,
            "& .MuiAutocomplete-endAdornment .MuiIconButton-root": {
              // Move dropdown arrow and clear X up to horizontal center
              height: "auto",
            },
            "& .MuiAutocomplete-popupIndicatorOpen": {
              // Stop MUI from rotating the icon by rotating it back
              rotate: "180deg",
            },
            "& .MuiInputLabel-root, .MuiInputBase-input": {
              fontSize: "14.5px",
            },
          }}
        />

        {action && OISSubheaderComponents[action.value]}
      </MuiStack>
    </MuiBox>
  );
};

export default OISSubheader;
